import { BridgeMessage } from './message'

const environment = process.env.NEXT_PUBLIC_ENVIRONMENT

export class NativeBridge {
  private debug = environment !== 'live'
  eventTarget = new EventTarget()

  constructor() {
    window.bridge = this
  }

  postMessage(messageProp: string): void {
    try {
      const message = JSON.parse(messageProp) as BridgeMessage

      const event = new CustomEvent('bridge', {
        detail: message,
      })

      if (this.debug) {
        console.log('[Bridge] Message from Native:', messageProp)
      }

      this.eventTarget.dispatchEvent(event)
    } catch (error) {
      if (this.debug) {
        console.error('[Bridge] Failed to parse message:', messageProp, error)
      }
    }
  }
}

export const createNativeBridge = () => {
  return new NativeBridge()
}
